import { OrdersState } from "../types";

export const loadersStates: Partial<OrdersState> = {
	loadedTable: null,
	loading: true,
	loadingOrderGroups: true,
	loadingDetail: true,
	loadingWaitingOrders: true,
	loadingOrdersByPerson: true,
	loadingNext: true,
	loadingError: ''
};